import React from 'react';
import Filters from './Filters';
import SpecialtyPromotion from './SpecialtyPromotion';

const Sidebar = ({categories, contentTypes, updateTypes, updateCategories, submitUpdate, categoryIds, id, categoryIdPreSelected}) => {

  return (
    <div className="small-2 columns show-for-large-up">
      <Filters
        categories={categories}
        categoryIds={categoryIds}
        contentTypes={contentTypes}
        updateTypes={updateTypes}
        updateCategories={updateCategories}
        submitUpdate={submitUpdate}
        id={id}
        categoryIdPreSelected={categoryIdPreSelected}
      />
      {categoryIdPreSelected &&
        <SpecialtyPromotion categoryIdPreSelected={categoryIdPreSelected} />
      }
    </div>
  )
}

export default Sidebar